import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import router from './router'

// ✅ Importa o plugin do GTM
import VueGtm from 'vue-gtm'

const app = createApp(App)

// ✅ Usa o GTM com seu ID
app.use(VueGtm, {
  id: 'GTM-5D6BP2S', // 🔁 Substitua pelo seu ID do GTM, ex: GTM-ABC1234
  enabled: true,
  debug: false,
  vueRouter: router, // conecta com o Vue Router, se desejar
})

app.use(router).mount('#app')
